var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_731_33",
    "data-name": "Component 731 \\u2013 33",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.6,
    height: 20.666,
    viewBox: "0 0 18.6 20.666",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-date-range",
    "data-name": "Icon material-date-range",
    d: "M10.7,12.3H8.633v2.067H10.7Zm4.133,0H12.766v2.067h2.067Zm4.133,0H16.9v2.067h2.067Zm2.067-7.233H20V3H17.933V5.067H9.667V3H7.6V5.067H6.567A2.057,2.057,0,0,0,4.51,7.133L4.5,21.6a2.066,2.066,0,0,0,2.067,2.067H21.033A2.073,2.073,0,0,0,23.1,21.6V7.133A2.073,2.073,0,0,0,21.033,5.067Zm0,16.533H6.567V10.233H21.033Z",
    transform: "translate(-4.5 -3)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.bf788335.svg";
export { ForwardRef as ReactComponent };